import React, { Component } from 'react'
import starIcon from '../../icons/star.svg';
import starIconFilled from '../../icons/star_filled.svg';
// import tagIcon from '../../icons/95x95.png'
import { connect } from 'react-redux'
import { contentFunctions } from './RestaurantSummaryFunctions'
import { iconSwitch } from './IconSwitch'
import { Link } from 'react-router-dom'
import ReviewSummary from '../users/ReviewSummary2'
import { updateSortOptions, addFavorite2 } from '../../store/actions/restaurantActions'
import ScrollToTop from '../layout/ScrollToTop'
import Reddit from '../reddit/Reddit'

class RestaurantSummary extends Component { 
  constructor (props){
    super(props);
    this.state = {
    lastClicked: '',
    newLastClicked: '',
    allContentToClicked: '',
    httpResponse:'',
    mapUrl:'',
    blurb:'',
    iconImage:'',
    iconSize: 60,
    iconPadding: '20%',
    spanOption:'grid-test',
    reviewStars:'unknown',
    reviewer:[],
    reviewCount:'',
    isFavorite: false,
    favCount: 'unknown'
    }
  }

  onFavorite = (project) => {
    if(this.props.user.firstName === "Guest"){
      alert("Guest Users may not add favorites")  
    }
    else{
      this.props.addFavorite2(project);
    }
      }


  componentDidMount(props){

    if(this.state.lastClicked === "" && this.props.project.content !== ""){
      this.setState({lastClicked:this.state.blurb})
    }

    if(this.props.firestore && this.props.firestore.data && this.props.firestore.data.favorites && 
      this.props.project){
      var favCount = 0;
      for(var fav in this.props.firestore.data.favorites){
        if(this.props.firestore.data.favorites[fav][this.props.project.restaurantId]){
          favCount = favCount + 1;
        }
      }
      if(this.state.favCount !== favCount){
        this.setState({favCount:favCount})  
      }
    }
    
    var reviewer = [];
    if(this.props.reduxStore.restaurantReviews && this.props.reduxStore.users){
      var reviewSum = 0;
      var reviewCount2 = 0;   
      var reviewAverage = reviewSum/reviewCount2;
      reviewAverage = Math.round((reviewAverage + Number.EPSILON) * 100) / 100;
      if(this.state.reviewStars !== reviewAverage){
        this.setState({
          reviewStars: reviewAverage,
          blurb:'',
          lastClicked:'',
          reviewer:reviewer
        })  
      }  
    }

    var blurb = '';

    if(this.props.project && this.props.project.tags && this.props.distance !== undefined && this.props.isOpen !== undefined && this.props.opensAt !== undefined && this.state.clopen !== undefined){
      const openIsit = this.props.isOpen?"open":"closed";
      const roundedDistance = Math.round((this.props.distance + Number.EPSILON) * 100) / 100;
      blurb = this.props.project.primaryTag + ',' + openIsit + ',' + roundedDistance.toString() + 
      ',' + reviewCount2 + ',' + this.state.reviewStars + ',' + this.state.favCount + ',' + this.props.opensAt + ',' 
      + this.props.redditCount   

      if(blurb !== '' && this.state.blurb !== blurb){
        this.setState({blurb:blurb,lastClicked:''})
      }

      
      if(this.state.iconImage === '' && this.props.project){
        iconSwitch(this.props.project.primaryTag, this)
      }

      if(blurb !== '' && this.state.blurb !== blurb){
        this.setState({blurb:blurb,lastClicked:''})
        }

      if(this.state.lastClicked === this.props.project.content && this.state.blurb !== ''){
        this.setState({lastClicked:this.state.blurb})
      }

      if(this.state.lastClicked === this.props.project.address && this.state.spanOption !== 'grid-test2'){
        this.setState({spanOption:'grid-test2'})
      }
      else if(this.state.lastClicked !== this.props.project.address &&this.state.spanOption !== 'grid-test'){
        this.setState({spanOption:'grid-test'})
      }

    }
    if(this.props.isOpen !== undefined && this.state.clopen === undefined){
        this.props.isOpen?this.findClose():this.findOpen();
      }
    }

  componentDidUpdate(props){
    if(this.state.scrollToTop){
      this.setState({scrollToTop:false});
    }
    if(this.props.auth && this.props.firestore && this.props.firestore.data && 
      this.props.firestore.data.favorites && this.props.firestore.data.favorites[this.props.auth.uid]){
        var favorite = this.props.firestore.data.favorites[this.props.auth.uid][this.props.project.restaurantId];
        if(favorite && !this.state.isFavorite){
          this.setState({isFavorite:true})
        }
        else if(!favorite && this.state.isFavorite){
          this.setState({isFavorite:false})
        }
      
      }
    
    if(this.props.firestore && this.props.firestore.data && this.props.firestore.data.favorites && 
      this.props.project){
      var favCount = 0;
      for(var fav in this.props.firestore.data.favorites){
        if(this.props.firestore.data.favorites[fav][this.props.project.restaurantId]){
          favCount = favCount + 1;
        }
      }
      if(this.state.favCount !== favCount){
        this.setState({favCount:favCount})  
      }
    }
    


    switch(this.state.newLastClicked){
        case 'hours':
          if(this.state.lastClicked !== this.props.project.hours){
            this.setState({lastClicked:this.props.project.hours})
          }
          break;
        case 'address':
          if(this.state.lastClicked !== this.props.project.address){
            this.setState({lastClicked:this.props.project.address})
          }
          break;
        case 'tags':
          if(this.state.lastClicked !== this.props.project.tags){
            this.setState({lastClicked:this.props.project.tags})
          }
          break;
        case 'content':
          if(this.state.lastClicked !== this.state.blurb){
            this.setState({lastClicked:this.state.blurb})
          }
          break;
        case 'reviews':
          if(this.state.lastClicked !== 'Click or tap on a review to expand.'){
            this.setState({lastClicked:'Click or tap on a review to expand.'})
          }
          break;
        case 'reddit':
          if(this.state.lastClicked !== 'reddit'){
            this.setState({lastClicked:'reddit'})
          }
          break;
        default:
          if(this.state.lastClicked !== this.state.blurb){
            this.setState({lastClicked:this.state.blurb})
          }
          break;
      }

    if(this.state.lastClicked === "" && this.props.project.content !== "" && this.state.lastClicked !== this.state.blurb){
      this.setState({lastClicked:this.state.blurb})
    }

    if(this.props.firestore.data.restaurantReviews2 && this.props.firestore.ordered.users){
      var revs = this.props.firestore.data.restaurantReviews2;
      var users = this.props.firestore.ordered.users;
      var reviewSum = 0;
      var reviewCount2 = 0;
      var reviewer = [];
      if(revs!==undefined && revs!==null){
        Object.entries(revs).forEach(rev=>{
        if(rev[1] !== null && rev[1].restaurantId === this.props.project.restaurantId){
          reviewCount2 = reviewCount2 + 1;
          reviewSum = reviewSum + rev[1].review.reviewScore;
          var key = rev[0];
          reviewer.push([<ReviewSummary key={"review"+key} project={ rev[1].review } original={this.props.project}/>])  
          }
        })
        var reviewAverage = reviewSum/reviewCount2;
        reviewAverage = Math.round((reviewAverage + Number.EPSILON) * 100) / 100;
      }
      if(reviewer !== [] && JSON.stringify(this.state.reviewer) !== JSON.stringify(reviewer)){
          this.setState({
            reviewer:reviewer,
            reviewStars: reviewAverage,
            reviewCount: reviewCount2,
          })
        }
      
    }
    
    if(this.props.allContent !== this.state.allContentToClicked){

      switch(this.props.allContent.value){
        case 'hours':
          this.setState({lastClicked:this.props.project.hours, allContentToClicked:this.props.allContent})
          break;
        case 'address':
          this.setState({lastClicked:this.props.project.address, allContentToClicked:this.props.allContent})
          break;
        case 'tags':
          this.setState({lastClicked:this.props.project.tags, allContentToClicked:this.props.allContent})
          break;
        case 'content':
          this.setState({lastClicked:this.state.blurb, allContentToClicked:this.props.allContent})
          break;
        case 'reviews':
          this.setState({lastClicked:'Click or tap on a review to expand.', allContentToClicked:this.props.allContent})
          break;
        default:
          this.setState({lastClicked:this.state.blurb, allContentToClicked:this.props.allContent})
          break;
      }
    }

    if(this.state.mapUrl === ''){
      this.getMap()
    }

    var blurb = '';
    
    if(this.props.project && this.props.distance !== undefined && this.props.project.tags && this.props.isOpen !== undefined && this.props.opensAt !== undefined && this.state.clopen !== undefined){
      const openIsit = this.props.isOpen?"open":"closed";
      const roundedDistance = Math.round((this.props.distance + Number.EPSILON) * 100) / 100;
      blurb = this.props.project.primaryTag + ',' + openIsit + ',' + roundedDistance.toString() + 
      ',' + reviewCount2 + ',' + this.state.reviewStars + ',' + this.state.favCount + ',' + this.props.opensAt + ',' 
      + this.props.redditCount
      
      if(blurb !== '' && this.state.blurb !== blurb){
        this.setState({blurb:blurb,lastClicked:''})
      }

      if(this.state.iconImage === ''  && this.props.project){
        iconSwitch(this.props.project.primaryTag, this);
      }

      if(blurb !== '' && this.state.blurb !== blurb){
        this.setState({blurb:blurb,lastClicked:''})
        }

      if(this.state.lastClicked === this.props.project.content && this.state.blurb !== ''){
        this.setState({lastClicked:this.state.blurb})
      }

      if(this.state.lastClicked === this.props.project.content && this.state.lastClicked !== this.state.blurb){
       this.setState({lastClicked:this.state.blurb}) 
      }

      if(this.state.lastClicked === this.props.project.address && this.state.spanOption !== 'grid-test2'){
        this.setState({spanOption:'grid-test2'});
        // document.getElementById("contentBox"+this.props.project.id).style.overflowY = "scroll";
      }
      else if(this.state.lastClicked !== this.props.project.address && this.state.spanOption !== 'grid-test'){
        this.setState({spanOption:'grid-test'});
        // document.getElementById("contentBox"+this.props.project.id).style.overflowY = "visible";
      }
      // if(this.state.lastClicked === 'Click or tap on a review to expand.'){
      //   document.getElementById("contentBox"+this.props.project.id).style.overflowY = "auto";
      // }
      // else if(this.state.lastClicked !== 'Click or tap on a review to expand.'){
      //   document.getElementById("contentBox"+this.props.project.id).style.overflowY = "visible";
      // }
    }
      if(this.props.isOpen !== undefined && this.props.opensAt !== undefined && this.state.clopen === undefined){
        //this.props.isOpen?this.findClose():this.findOpen();
        this.setState({clopen:this.props.opensAt})
      }

  }

  findOpen = () => {
    var d = new Date();
    var n = d.getDay();
      //console.log("hourssplit");
      //console.log(this.props.project.hours[n].split(" - ")[1]);

      if(this.props.project.hours[n].split(" - ")[1] === " PM"){
        var nextDay = (n+1)%7;
        //console.log('this is x4 on the piece of paper ' + nextDay);
        if(this.props.project.hours[nextDay] === " AM -  PM"){
          //console.log('next day closed');
          var overFlowCount = 0;
          while(this.props.project.hours[nextDay] === " AM -  PM" && overFlowCount < 10){
            overFlowCount = overFlowCount + 1;
            nextDay = (nextDay+1)%7
          }
          //console.log(overFlowCount);
          //console.log(contentFunctions.dayOfWeek(nextDay));
          if(overFlowCount < 9){
            this.setState({clopen:" opens " + contentFunctions.dayOfWeek(nextDay) + " at " + this.props.project.hours[nextDay].split(" - ")[0]})
          }


        }

        //console.log(this.props.project.hours[nextDay])
      }
      else{
        var nextDay = (n+1)%7;
      
        if(this.props.project.hours[nextDay] === " AM -  PM"){
          //console.log('next day closed');
          var overFlowCount = 0;
          while(this.props.project.hours[nextDay] === " AM -  PM" && overFlowCount < 10){
            overFlowCount = overFlowCount + 1;
            nextDay = (nextDay+1)%7
          }
          //console.log(overFlowCount);
          //console.log(contentFunctions.dayOfWeek(nextDay));
          if(overFlowCount < 9){
            this.setState({clopen:" opens " + contentFunctions.dayOfWeek(nextDay) + " at " + this.props.project.hours[nextDay].split(" - ")[0]})
          }

        }
        else{
          this.setState({clopen:" opens at " + this.props.project.hours[n].split(" - ")[0]})  
        }
      }
  }

  findClose = () => {
    var d = new Date();
    var n = d.getDay();
    this.setState({clopen:" closes at " + this.props.project.hours[n].split(" - ")[1]})
  }
  
  handleTagClick = () => {
    this.setState({"scrollToTop":true});
    var sortOptions = this.props.restaurant.sortOptions;
    sortOptions.sortTags = [{"value":this.props.project.primaryTag,"label":this.props.project.primaryTag}];
    sortOptions.sortCombined = [{"value":this.props.project.primaryTag,"label":this.props.project.primaryTag}];
    sortOptions.summaryChange = true;
    this.props.updateSortOptions(sortOptions);
  }

  tagCallbackFunction = (tag) => {
    this.setState({"scrollToTop":true});
    var sortOptions = this.props.restaurant.sortOptions;
    sortOptions.sortTags = [{"value":tag,"label":tag}];
    sortOptions.sortCombined = [{"value":tag,"label":tag}];
    sortOptions.summaryChange = true;
    this.props.updateSortOptions(sortOptions);
  }

  getMap(){  
    const centerPoint = this.props.project.location;
    const mapUrl = "https://dev.virtualearth.net/REST/v1/Imagery/Map/Road/"+centerPoint+"/15?mapSize=360,350&pp="+centerPoint+"&format=PNG&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O"
    if(this.state.mapUrl !== mapUrl){
      this.setState({mapUrl:mapUrl});
      }   
    //https://dev.virtualearth.net/REST/v1/Imagery/Map/Road/Routes?wp.0=Seattle,WA;64;1&wp.1=Redmond,WA;66;2&key={BingMapsAPIKey}   
  }

  render() { 
  const { project } = this.props;
  const favIcon = this.state.isFavorite?starIconFilled:starIcon;
  const online_or_menu = project.orderUrl!==""?project.orderUrl:project.menuUrl;
  const online_menu = project.orderUrl!==""?'Order':'Menu';
  if(this.state.scrollToTop){
    return(<ScrollToTop/>)
  }
  
  return (
    <div className={this.state.spanOption}>
      <div className='tagIcon' onClick={ this.handleTagClick } ><img alt="Tag Icon" style={{"paddingRight":this.state.iconPadding}} height={this.state.iconSize} src={this.state.iconImage}/></div>
  <div className='image-stack'>
    <div className="new-wrapper">
        <div className="new-nav-text2">
            <div><a onClick={ () => this.setState({newLastClicked: 'content'}) }>{project.name}</a></div>
        </div>

        <div className="new-nav-text">
            <div><a onClick={ () => {if(this.state.newLastClicked !== 'reviews'){this.setState({newLastClicked: 'reviews'})}
            else{this.setState({newLastClicked:'content'})} } }>Reviews</a></div>
            <div><a onClick={ () => {if(this.state.newLastClicked !== 'hours'){this.setState({newLastClicked: 'hours'})}
            else{this.setState({newLastClicked:'content'})} } }>Hours</a></div>
            <div><a onClick={ () => {if(this.state.newLastClicked !== 'address'){this.setState({newLastClicked: 'address'})}
            else{this.setState({newLastClicked:'content'})} } }>Address</a></div>
            <Link to={'/edit/' + project.restaurantId} key={project.restaurantId}>Edit</Link>
            <div><img src={favIcon} onClick={() => this.onFavorite(project)} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            
        </div>
        
        <div className="new-main" id={"contentBox"+project.id} style={{overflowY:"auto", overflowX:"hidden"}}>
          <div>{ contentFunctions.displayContent(this.state.lastClicked, project, this.tagCallbackFunction, this) }</div>

          <p> { this.state.lastClicked===project.address && this.state.mapUrl!=='' && <img alt='Map' className="mapImage" src = {this.state.mapUrl}/> } </p>
          <div> { this.state.lastClicked==='reddit' && <Reddit restaurant={project.name}/> } </div>
          <p> { this.state.lastClicked==='Click or tap on a review to expand.' && <Link to={{pathname: '/reviews/' + project.restaurantId, state: {project: project}}} key={'review'+project.restaurantId}>Write a review</Link>  } </p>
          {
           this.state.lastClicked==='Click or tap on a review to expand.' && this.props.firestore.data.restaurantReviews2 && this.state.reviewer &&
            this.state.reviewer
          }
        </div>
      
        <div className="new-bottom">
          <div><a onClick = {() => newWindow(project.url)}>Site</a></div>
          {/*<div><a onClick = {() => newWindow('localhost:3000/reddit/'+project.name)}>Reddit</a></div>*/}
          <div><a onClick = {() => newWindow(online_or_menu)}>{online_menu}</a></div>
          <div><a href={"tel:" + project.phoneNumber}>{project.phoneNumber}</a></div>
          <div><a onClick = { () => {if(this.state.newLastClicked !== 'reddit'){this.setState({newLastClicked: 'reddit'})}
            else{this.setState({newLastClicked:'content'})} } }>Reddit</a></div>
          <div><a onClick={ () => {if(this.state.newLastClicked !== 'tags'){this.setState({newLastClicked: 'tags'})}
            else{this.setState({newLastClicked:'content'})} } }>Tags</a></div>
        </div>

    </div>
  </div>
  </div>
  )
}
}

function newWindow(url) {
		var newWind = window.open('http://' + url, '_blank');
		newWind.opener = null;
	}

const mapStateToProps = (state, props) => {
  const thisReview = state.firestore.data['review_'+props.project.restaurantId];
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    ...state,
    auth:state.firebase.auth,
    restaurant: state.restaurant,
    redditCount: state.firestore.ordered.redditCount[0]['countDict'][props.project.name.replace('/','')],
    thisReview,
    user

  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateSortOptions: (state) => dispatch(updateSortOptions(state)),
    addFavorite2: (project) => dispatch(addFavorite2(project))
  }
}
// export default connect(mapStateToProps)(RestaurantSummary)


export default connect(mapStateToProps,mapDispatchToProps)(RestaurantSummary)